import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTurkishCharachtersDirective } from './input-turkish-charachters.directive';



@NgModule({
  declarations: [
    // InputTurkishCharachtersDirective
  ],
  exports: [
    // InputTurkishCharachtersDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
